import axios from "axios";

const PUBLIC_ENDPOINT_PREFIXES = ["/scholarships", "/readiness-checker"];

const isPublicEndpoint = (url = "") => {
  const rawUrl = String(url);
  const withoutQuery = rawUrl.split("?")[0];
  return PUBLIC_ENDPOINT_PREFIXES.some((prefix) => withoutQuery.startsWith(prefix));
};

const removeHeader = (headers, name) => {
  if (!headers) return;
  if (typeof headers.delete === "function") {
    headers.delete(name);
    headers.delete(name.toLowerCase());
    return;
  }

  delete headers[name];
  delete headers[name.toLowerCase()];
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://admin.scholarstoday.id/api",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      removeHeader(config.headers, "Content-Type");
    }

    if (isPublicEndpoint(config.url)) {
      if (config.headers?.Authorization) {
        delete config.headers.Authorization;
      }
      return config;
    }

    const token = localStorage.getItem("token");
    // console.log("Interceptor - Request ke:", config.url, "Token:", token || "Kosong"); // Debug
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("Token tidak ditemukan untuk request:", config.url);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Interceptor - Error response:", error.response?.status, error.response?.data || error.message);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect) {
      console.warn("Token expired, logging out...");

      localStorage.removeItem("token");
      localStorage.removeItem("ielts_user");
      localStorage.removeItem("identity_id");

      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);


export default api;
